export const bodyItemWidthDecider = (width?: number, defaultWidth?: number) => {
    if(width){
        return width
    }
    if(defaultWidth){
        return defaultWidth
    }
    return 'auto'
}